import { useEffect, useState } from "react";
import { DateObject } from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import VerificationLayout from "../../layout/apartmentVerificationLayout";
import { fetchBooking, fetchUnitBooking } from "../../store/slices/booking/bookingSlice";
import { AppDispatch } from "../../store/slices/properties/types";
import { RootState } from "../../store/store";
import ScheduleViewer from "../../components/schedule-viewer";

const Booking = () => {
    const router = useNavigate();
    const [time, setTime] = useState('')
    const [timeValid, setTimeValid] = useState<boolean>(false)
    const [date, setDate] = useState<DateObject | DateObject[] | null | any>(null);

    const dispatch = useDispatch<AppDispatch>();
    const { activeBooking, bookingDate } = useSelector((state: RootState) => state.booking)

    useEffect(() => {
        setDate(bookingDate.prevBookingDate || undefined)
        setTime(bookingDate.prevBookingTime || undefined)
    }, [bookingDate])


    useEffect(() => {
        const hoursString = time?.split(':')
        const hours = parseInt(hoursString?.[0])
        if (hours >= 10 && hours < 16) {
            setTimeValid(true)
        }
        else {
            setTimeValid(false)
        }
    }, [time])


    let { slug } = useParams();

    useEffect(() => {
        if (slug) {
            let slugArray = slug.split("-");
            const slugLength = slugArray.length
            const localPropertyId = slugArray[slugLength - 1]

            if (slugLength === 1) {
                localPropertyId ? dispatch(fetchBooking(localPropertyId)) : toast.error('Booking not found')
            }
            else {
                localPropertyId ? dispatch(fetchUnitBooking(localPropertyId)) : toast.error('Booking not found')
            }
        }
    }, [slug])

    return (
        <VerificationLayout route="Booking">
            {
                activeBooking.can_book &&
                <div className="booking">
                    <h3>Booking</h3>
                    <p>Please select a date</p>
                    <ScheduleViewer available_at={activeBooking?.available_at} schedule={activeBooking?.schedule} />
                </div>
            }

        </VerificationLayout>
    )
}
export default Booking;
